import MomentUtils from '@date-io/moment';
import { makeStyles } from '@material-ui/core';
import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import moment from 'moment';
import React from 'react';

// Ô chọn ngày giờ của các màn báo cáo — dựng trên KeyboardDateTimePicker của Material-UI.
//
// Trước ec2202a7 (19/08/2026) mỗi màn tự đặt KeyboardDateTimePicker của mình. Commit đó gom
// chúng vào component chung này nhưng đổi luôn ruột sang DatePicker của antd, nên dáng và cách
// dùng đổi theo ở cả 34 chỗ. Nay quay lại Material-UI theo yêu cầu, GIỮ NGUYÊN component chung:
// phần gom lại là đúng, chỉ có việc đổi thư viện là không mong muốn.
//
// Vì vậy props giữ y nguyên (dateTime / onChange / format / showTime / width) và không màn nào
// phải sửa. Đã rà cả 34 chỗ gọi: chúng chỉ dùng đúng chừng đó props — không nơi nào dùng `onOk`
// hay `style`, nên việc antd có onOk mà Material-UI không có là vô hại.
//
// Khác biệt hành vi mà người dùng sẽ thấy, và đó chính là điều được yêu cầu: bản antd bắt bấm
// "OK" mới chốt giờ, còn bản này chốt ngay khi đổi và cho gõ thẳng bằng bàn phím.
// KHÔNG chốt cứng chiều cao ở đây.
//
// Mỗi màn tự đặt kích thước ô tìm kiếm của mình qua class searchComponent, và các con số không
// giống nhau: Báo cáo BGT dùng 260×34, Báo cáo Doanh nghiệp dùng 280×38. Một chiều cao cố định
// trong component dùng chung thì đúng ở màn này và lệch ở màn kia — đã thử 30px rồi 40px, mỗi lần
// chỉ chữa được một nửa số màn.
//
// Nên màn nào cũng truyền chính searchComponent của nó vào `className`, tức ô ngày lấy đúng kích
// thước của ô Autocomplete đứng cạnh. Khớp theo cấu tạo, không phải theo con số chép tay.
//
// `fallback` chỉ dùng khi người gọi không truyền className, để component vẫn có hình dạng hợp lý.
const useStyles = makeStyles({
  fallback: {
    '& .MuiOutlinedInput-root': {
      height: '40px'
    }
  }
});

// showTime là di sản của antd: ở antd nó bật phần chọn giờ. KeyboardDateTimePicker luôn có sẵn
// giờ nên tham số này không còn tác dụng. Vẫn nhận vào để 34 chỗ gọi không phải sửa, và để React
// không đẩy một prop lạ xuống thẻ DOM.
const DateTimeReport = ({ showTime, format, dateTime, onChange, width, style, className }) => {
  const classes = useStyles();
  return (
    <MuiPickersUtilsProvider utils={MomentUtils} libInstance={moment}>
      <KeyboardDateTimePicker
        variant="inline"
        inputVariant="outlined"
        format={format}
        value={dateTime}
        onChange={onChange}
        ampm={false}
        classes={{ root: className || classes.fallback }}
        InputProps={{ className: className || classes.fallback }}
        style={{
          // Khi màn đã truyền className thì bề ngang do class đó quyết định; chỉ đặt width khi
          // người gọi nói rõ, để không ghi đè lên kích thước của chính màn đó.
          ...(width
            ? { width: typeof width === 'number' ? `${width}px` : width }
            : className
            ? {}
            : { width: '260px' }),
          ...style
        }}
      />
    </MuiPickersUtilsProvider>
  );
};

export default React.memo(DateTimeReport);
